
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...uid]",
      function () {
        return require("private-next-pages/[...uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...uid]"])
      });
    }
  